<template>
  <Layout :adShopMallAreaId="2">
    <!-- {{ adMap }} -->
    <div class="mb6" style="margin:50px 0 0;">
      <MyCarousel class="home-left" :id="4" :showTitle="false" :params="{ResRefId: id}"></MyCarousel>
      <clinical-intro></clinical-intro>
      <sec-nav page="clinical" class="mt3"></sec-nav>
      <long-banner :ad="adMap[1]"></long-banner>
      <!--培训课堂-->
      <div id="train" class="home-row">
        <TrainingClass class="home-left" :params="{ CategoryType: 1, CategoryId: id }"></TrainingClass>
        <top-hits class="home-right" :params="{ CategoryType: 1, CategoryId: id }"></top-hits>
      </div>
      <!--侃侃病例-->
      <div id="cases" class="home-row">
        <DiseaseList class="home-left" :params="{ CategoryType: 1, CategoryId: id }"></DiseaseList>
        <div class="home-right">
          <ProdFocusText></ProdFocusText>
          <ProdFocus :ad="adMap[4]"></ProdFocus>
        </div>
      </div>
      <!--会议资讯-->
      <div id="meeting" class="home-row">
        <MeetingList class="home-left" :params="{ CategoryType: 1, CategoryId: id }"></MeetingList>
        <div class="home-right">
          <AdMeeting :ad="adMap[3]" />
          <latest-meeting :params="{ CategoryType: 1, CategoryId: id }" :showMore="true"></latest-meeting>
        </div>
      </div>
      <!--热点资讯-->
      <div id="news" class="home-row">
        <NewsList class="home-left" :params="{ CategoryType: 1, CategoryId: id }"></NewsList>
        <latest-hot class="home-right mt1" :params="{ CategoryType: 1, CategoryId: id }"></latest-hot>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../../layout';
import MyCarousel from '../../components/common/MyCarousel';
import ClinicalIntro from '../../components/clinical/Introduction';
import LongBanner from '../../components/ad/long';
import AdMeeting from '../../components/ad/meeting';
import SecNav from '../../components/home/SecNav';
import ProdFocus from '../../components/ad/long-v';
import LatestMeeting from '../../components/meeting/Latest';
import LatestHot from '../../components/hot/Latest';
import TrainingClass from '../../components/TrainingClass';
import TopHits from '../../components/TopHits';
import MeetingList from '@/components/meeting-list';
import ProdFocusText from '../../components/common/prodFocus';
import NewsList from '@/components/news-list';
import DiseaseList from '@/components/disease-list';

export default {
  components: {
    Layout,
    MyCarousel,
    NewsList,
    ClinicalIntro,
    SecNav,
    ProdFocus,
    LongBanner,
    ProdFocusText,
    LatestMeeting,
    LatestHot,
    TrainingClass,
    TopHits,
    MeetingList,
    DiseaseList,
    AdMeeting,
  },
  data() {
    const { id } = this.$utils.query2Obj(location.search);
    return { id };
  },
  computed: {
    adMap() {
      return (this.$store.state.ad.adMap[4] || {})[this.id] || {};
    },
  },
  created() {
    this.$store.dispatch('ad/getAds');
  },
};
</script>

<style lang="scss">
.banner {
  width: 100%;
}
</style>
